import { RSAA, getJSON } from "redux-api-middleware";

import { PASSCODE_SERVER } from "../../constants/constants";
import { SELECT_VALUES } from "../../utils/responseValue";
import { initialState as passcode } from "../../reducers/passcodeManager";

export const PM_GET_CONFERENCES_REQUEST = "PM_GET_CONFERENCES_REQUEST";
export const PM_GET_CONFERENCES_SUCCESS = "PM_GET_CONFERENCES_SUCCESS";
export const PM_GET_CONFERENCES_FAILURE = "PM_GET_CONFERENCES_FAILURE";

export const PM_PUT_CONFERENCES_REQUEST = "PM_PUT_CONFERENCES_REQUEST";
export const PM_PUT_CONFERENCES_SUCCESS = "PM_PUT_CONFERENCES_SUCCESS";
export const PM_PUT_CONFERENCES_FAILURE = "PM_PUT_CONFERENCES_FAILURE";

export const PM_GET_SELECT_VALUES_REQUEST = "PM_GET_SELECT_VALUES_REQUEST";
export const PM_GET_SELECT_VALUES_SUCCESS = "PM_GET_SELECT_VALUES_SUCCESS";
export const PM_GET_SELECT_VALUES_FAILURE = "PM_GET_SELECT_VALUES_FAILURE";

export const PM_CHANGE_PASSCODE_REQUEST = "PM_CHANGE_PASSCODE_REQUEST";
export const PM_CHANGE_PASSCODE_SUCCESS = "PM_CHANGE_PASSCODE_SUCCESS";
export const PM_CHANGE_PASSCODE_FAILURE = "PM_CHANGE_PASSCODE_FAILURE";

export const PM_RESET_FILTER = "PM_RESET_FILTER";
export const PM_SET_FILTER = "PM_SET_FILTER";
export const PM_RESET_ERROR = "PM_RESET_ERROR";

const successPayload = (action, state, res) => {
  return getJSON(res).then(json => json);
};

export const resetFilter = () => ({
  type: PM_RESET_FILTER,
});

export const setFilter = filter => ({
  type: PM_SET_FILTER,
  filter,
});

const requestFilterBuilder = (value, filterKey, paramName) =>
  value !== passcode.filter[filterKey] ? `&${paramName}=${btoa(value)}` : "";

/* :TODO
   orderBy: "",
  orderDirection: "", */
const mapQueryParam = filter => {
  let res = "";
  res += requestFilterBuilder(filter.confId, "confId", "confId");
  res += requestFilterBuilder(filter.hostPasscode, "hostPasscode", "hCode");
  res += requestFilterBuilder(filter.guestPasscode, "guestPasscode", "gCode");
  res += requestFilterBuilder(filter.eMail, "eMail", "eMail");
  res += requestFilterBuilder(filter.comment, "comment", "comment");
  res += requestFilterBuilder(filter.contractNumber, "contractNumber", "cNumber");
  res +=
    requestFilterBuilder(filter.creationDateFrom, "creationDateFrom", "cDateF") !== ""
      ? `&cDateF=${btoa(new Date(filter.creationDateFrom).getTime())}`
      : "";
  res +=
    requestFilterBuilder(filter.creationDateTo, "creationDateTo", "cDateT") !== ""
      ? `&cDateT=${btoa(new Date(filter.creationDateTo).getTime())}`
      : "";
  return res;
};

export const requestConferences = filter => ({
  [RSAA]: {
    endpoint: `${PASSCODE_SERVER}/pcm-backend/v1/audioconferences/searchpasscode?startIndex=${filter.page *
      filter.size}&size=${filter.size}${mapQueryParam(filter)}`,
    method: "GET",
    types: [
      PM_GET_CONFERENCES_REQUEST,
      {
        type: PM_GET_CONFERENCES_SUCCESS,
        payload: successPayload,
      },
      PM_GET_CONFERENCES_FAILURE,
    ],
  },
});

export const requestParams = () => ({
  [RSAA]: {
    endpoint: `${PASSCODE_SERVER}/pcm-backend/v1/passcodemanager/params?${SELECT_VALUES.map(
      p => `paramnames=${p}&`
    ).join("&")}&lang=De`,
    method: "GET",
    headers: { "Content-Type": "application/json" },
    types: [
      PM_GET_SELECT_VALUES_REQUEST,
      {
        type: PM_GET_SELECT_VALUES_SUCCESS,
        payload: successPayload,
      },
      PM_GET_SELECT_VALUES_FAILURE,
    ],
  },
});

export const updateConference = (id, conference) => ({
  [RSAA]: {
    endpoint: `${PASSCODE_SERVER}/pcm-backend/v1/audioconferences/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(conference),
    types: [
      PM_PUT_CONFERENCES_REQUEST,
      {
        type: PM_PUT_CONFERENCES_SUCCESS,
        payload: successPayload,
      },
      PM_PUT_CONFERENCES_FAILURE,
    ],
  },
});

/**
 * @param {string=} type can be MODERATOR_PIN, PARTICIPANT_PIN or BOTH
 */
export const updatePin = (id, type, conference) => ({
  [RSAA]: {
    endpoint: `${PASSCODE_SERVER}/pcm-backend/v1/audioconferences/${id}/generatepin/${type}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(conference),
    types: [PM_CHANGE_PASSCODE_REQUEST, PM_CHANGE_PASSCODE_SUCCESS, PM_CHANGE_PASSCODE_FAILURE],
  },
});

export const resetError = () => ({
  type: PM_RESET_ERROR,
});
